module.exports = __webpack_public_path__ + "img/domino-matrix-bg.18261c71.svg";